import {getCurrentNextItemRef, PageStateManager, Common, PageStyleType} from '@taopix/taopix-core';
import {StateManagerModuleInterface} from '@taopix/taopix-core/dist/types/Persistence/Modules';
import {
  ComputedPageItem,
  ReducerState,
  ShuffleLayout,
  ShuffleLayoutArgs,
} from '@taopix/taopix-core/dist/types/types';
import AutoLayout from '../Utils/AutoLayout/AutoLayout';

export default class ShuffleLayouts
  implements StateManagerModuleInterface<ShuffleLayoutArgs, {ref: number}>
{
  private processor: AutoLayout;

  constructor() {
    this.processor = new AutoLayout(); // TODO - this needs refactored but currently functions fine
  }

  public async call(
    manager: PageStateManager,
    args?: ShuffleLayoutArgs
  ): Promise<ReducerState & {ref: number}> {
    const {processor} = this;
    const layout = manager.getLayout();
    const items = manager.getPageItems(args?.pageNumber as number);
    processor.setPictureBoxesOnCurrentPage(
      items,
      getCurrentNextItemRef(),
      args?.pageNumber as number,
      layout.width,
      1 === layout.spreads
    );

    processor.setLayoutList(
      layout.shuffleLayouts as ShuffleLayout[],
      Common.getPageHasGrid(items as ComputedPageItem[]),
      args?.pageType as PageStyleType,
      layout.type,
      true
    );

    // get a random layout
    const ref = processor.getValidLayout(
      args?.pageType as PageStyleType,
      args?.type as 'left' | 'right' | 'spread',
      true
    );

    return {
      ...manager.getStoreState(),
      ref,
    };
  }
}
